<template>
  <div>
    <div class="section-right-content-box">
      <div class="box-shadow top-box">
        <div class="global-title">周期分析</div>
      </div>
      <div style="padding: 30px 28px 28px 28px">
        <div>
          <div
            id="order-care"
            :style="{ width: '100%', height: '400px' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { periodBuyerCountone } from "@/api/analysis/monthly-report";
export default {
  name: "monthly_report",
  data() {
    return {
      zxData: {
        timeFlag: [],
        buyerCount: [],
        tradeCount: [],
        payment: [],
        buyerAvgCost: [],
      },
    };
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  mounted: function () {
    this.periodBuyerCount();
    this.$nextTick(() => {
      this.drawOrderCareBar();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  methods: {
    periodBuyerCount() {
      let self = this;
      periodBuyerCountone({}).then((res) => {
        self.zxData.timeFlag = [];
        self.zxData.buyerCount = [];
        self.zxData.tradeCount = [];
        res.data.forEach((val, index) => {
          self.zxData.timeFlag.push(val.time); //时间段日期
          self.zxData.buyerCount.push(val.memberCount); //会员数
          self.zxData.tradeCount.push(val.buyTotalCount); //订单数
        });
        self.drawOrderCareBar();
      });
    },
    //绘制柱状图
    drawOrderCareBar() {
      let self = this;
      let orderCareBarChartOne = this.$echarts.init(
        document.getElementById("order-care"),
        "light"
      ); //初始化echats实例
      orderCareBarChartOne.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          barWidth: 20,
        },
        legend: { data: ["会员数", "订单数"] },
        xAxis: {
          // x轴
          type: "category",
          name: "时间",
          data: self.zxData.timeFlag,
        },
        yAxis: {
          // y轴
          type: "value",
           axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            name: "会员数",
            data: self.zxData.buyerCount,
            type: "bar",
            smooth: true,
            color: ["#4CDFC0"],
            barWidth: 20,
          },
          {
            name: "订单数",
            data: self.zxData.tradeCount,
            type: "bar",
            smooth: true,
            color: ["#4878FF"],
            barWidth: 20,
          },
        ],
      });
      window.onresize = function () {
        orderCareBarChartOne.resize();
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.section-right-content-box {
  min-width: 1066px;
  margin: 10px 20px 0 20px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;

  .echarts {
    width: 100%;
    height: 40px;
    background: #fafafa;
    opacity: 1;

    line-height: 40px;
  }
  .clos {
    width: 100%;
    height: 310px;
    background: #ffffff;
    border: 1px solid #f3f4f7;
    opacity: 1;
  }
}
</style>
